import { formatPlate } from '../domain/licensePlate'

interface LicensePlateProps {
  /** Any form of the plate; it is normalised and grouped before rendering. */
  value: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

/** A Dutch plate, drawn with the same Kenteken typeface the physical plates use. */
export function LicensePlate({ value, size = 'md', className }: LicensePlateProps) {
  const formatted = formatPlate(value)

  return (
    <span className={`plate plate--${size}${className ? ` ${className}` : ''}`}>
      <PlateBand className="plate__band" />
      <span className="plate__value">{formatted}</span>
      <span className="visually-hidden">kenteken {formatted}</span>
    </span>
  )
}

/**
 * The blue strip down the left of every EU plate.
 *
 * Shared with the search field so the box someone types into and the plate they get back are the
 * same object.
 *
 * No EU ring of stars above the country code, though a real plate has one. The band is around 24px
 * wide at its largest and under 10px in the site header, where a ring of twelve reads as a smudge
 * and crowds the "NL" into the lower half. The letters alone look more like a plate than the
 * accurate version does.
 */
export function PlateBand({ className }: { className: string }) {
  return (
    <span className={className} aria-hidden="true">
      NL
    </span>
  )
}
